import { Stack, type SxProps, type Theme } from '@mui/material';
import { memo } from 'react';
import { usePlatformNotifications } from '@/helpers/statsig/dynamicConfig/platformNotification';
import { mergeSx } from '@/utils/mergeSx';
import { PlatformNotification, type PlatformNotificationVariant } from './PlatformNotification';

export { type PlatformNotificationVariant } from './PlatformNotification';

/**
 * Renders every enabled entry of the `platform_notification` Statsig dynamic config: maintenance
 * windows, deprecation notices, anything platform-wide. Both the content and the number of banners
 * are managed from the Statsig console, so nothing here needs a deploy.
 *
 * Only mounted on authenticated pages.
 */
export const PlatformNotifications = memo(function PlatformNotifications({
  variant,
  sx,
}: {
  variant?: PlatformNotificationVariant;
  /** Applied to the wrapper, so spacing only exists when something is actually rendered. */
  sx?: SxProps<Theme>;
}) {
  const notifications = usePlatformNotifications();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <Stack direction="column" sx={mergeSx({ gap: 1, width: '100%' }, sx)}>
      {notifications.map((notification) => (
        <PlatformNotification key={notification.id} notification={notification} variant={variant} />
      ))}
    </Stack>
  );
});
